import { useIsMobileVariant } from '../use-is-mobile-variant'

/**
 * We have different spacing tokens for mobile and desktop
 * for some components like Cards, Drawers and Modals we use this.
 *
 * @important not to be used on dense variants, dense are mostly 2 for all
 */
export const useSpacingToken = () => {
  const isMobileVariant = useIsMobileVariant()

  return isMobileVariant ? 2 : 3
}
